/**
 * i18n — D11: italiano al lancio, struttura i18n da subito (keys, niente stringhe hardcoded).
 */
export const it = {
  appTitle: "project-HYPR",
  metaMilestone: "M1 — core loop sessione",
  today: "Oggi",
  log: "Log",
  account: "Account",
  // Oggi
  contesto: "Contesto",
  peso: "Peso",
  sonno: "Sonno",
  energia: "Energia",
  esercizi: "Esercizi",
  iniziaSessione: "Inizia sessione",
  riprendiSessione: "Riprendi sessione",
  prossimoSlot: "prossimo slot",
  // Sessione
  sessione: "Sessione",
  back: "◀",
  rest: "rest",
  restIdle: "—:—",
  restSalta: "salta",
  restEstendi: "+30s",
  esercizioCounter: "esercizio",
  prec: "‹ prec",
  succ: "succ ›",
  setCounter: "Set",
  rirTarget: "RIR target",
  reps: "Reps",
  carico: "Carico",
  meno: "meno",
  piu: "più",
  rir: "RIR",
  noteSet: "Note",
  warmupSet: "Warmup set",
  cue: "Cue",
  salvaSet: "Salva set",
  salvaAvanti: "Salva + avanti",
  salvaCorrezione: "Salva correzione",
  annulla: "Annulla",
  correggiUltimo: "Correggi ultimo set",
  correggi: "correggi",
  setCompletati: "Set completati",
  propostaUltimo: "proposta: ultimo set",
  propostaTemplate: "proposta: target template",
  propostaNessuna: "primo set — nessuna proposta",
  modificato: "modificato",
  correzioneInCorso: "correzione in corso",
  // Fine sessione
  terminaSessione: "Termina sessione",
  reviewTitle: "Review sessione",
  confermaChiudi: "Conferma e chiudi",
  noteSessione: "Note sessione",
  metricaIdentici: "set identici alla proposta",
  // Export / Log / Account
  esportaJsonl: "Esporta JSONL",
  esportaMd: "Esporta MD",
  exportJsonlShort: "jsonl",
  exportMdShort: "md",
  exportShareFailed: "condivisione non riuscita — export scaricato",
  logVuoto: "nessuna sessione — inizia da Oggi",
  nessunTemplate: "nessun template disponibile",
  colData: "data",
  colGiorno: "giorno",
  colSet: "set",
  colStato: "stato",
  statoInCorso: "in corso",
  statoCompletata: "completata",
  // carico (§1.5 load_type)
  loadBarbell: "bilanciere",
  loadBw: "BW",
  loadBwPlus: "BW+",
  // unità e marche di riga (D11: nessuna stringa prodotto fuori da qui)
  unitKg: "kg",
  unitH: "h",
  unitSu5: "/5",
  unitMin: "min",
  unitSec: "s",
  markWarmup: "warmup",
  markCorretto: "corretto",
  markOk: "✓",
  metricaIdenticiTitolo: "Set identici alla proposta (D51)",
  // account (D54: display_name — default esplicito + edit inline)
  nome: "Nome",
  salvaNome: "Salva nome",
  defaultDisplayName: "atleta",
  // import/backup (M2: export → installazione pulita → import → stato identico)
  importaJsonl: "Importa JSONL",
  importReport: "import",
  importNuovi: "nuovi",
  importDuplicati: "duplicati",
  importConflitti: "conflitti",
  importScartati: "scartati",
  importMotivi: "motivi",
  // D55 (blind review M2 MAJOR 1): tombstone riconosciuti, conservati, mai applicati in silenzio
  importTombstone: "tombstone conservati, non applicati (semantica da M7)",
  // blind review M2 MINOR 1: conflitto interno al file = canonico minimo, dichiarato
  importConflittiInterni: "conflitti interni al file (importato il canonicamente minimo)",
  // blind review M2 MINOR 2: il resoconto di migrazione si ispeziona, non si getta
  importMigrazione: "migrazione",
  migrazioneDaV0: "eventi completati (v0→v1)",
  migrazioneRicollegati: "set ricollegati",
  migrazioneOrfani: "set orfani",
  migrazioneNomi: "nomi default",
  // D56 (blind review M2 MAJOR 2): identità — bootstrap dal file o conflitto dichiarato
  importIdentitaAdottata: "identità adottata dal file (bootstrap)",
  importIdentitaConflitto: "identità multiple — nessuna fusione silenziosa, decide il sync (D24)",
  // export Markdown (§3.2) — D11: anche i report sono stringhe prodotto
  mdSessione: "Sessione",
  mdDurata: "Durata",
  mdStato: "Stato",
  mdNoteSessione: "Note sessione",
  mdColEsercizio: "Esercizio",
  mdColSet: "Set",
  mdColReps: "Reps",
  mdColKg: "Kg",
  mdColRir: "RIR",
  mdColNote: "Note",
  fileSenzaData: "senza-data",
  slugFallback: "sessione",
  tipoPrec: "tipo carico precedente",
  tipoSucc: "tipo carico successivo",
  events: "Eventi",
  colType: "tipo",
  colTime: "timestamp",
  colId: "event_id",
  statusPersisted: "persisted",
  statusQuota: "quota",
  statusEvents: "eventi",
  statusSchema: "schema",
  statusStorage: "storage",
  statusSpace: "spazio dati",
  statusVersion: "versione",
  statusSw: "sw",
  perfLcp: "lcp",
  perfInp: "inp",
  perfCls: "cls",
  perfRt: "rt",
  perfEt: "event timing",
  etEntries: "entry",
  naEngine: "n/a (motore)",
  naIid: "n/a (iid)",
  naEntries: "n/a (nessuna entry)",
  yes: "si",
  no: "no",
  unknown: "?",
  storageError: "storage non disponibile — i dati restano in memoria per questa sessione",
  saveFailed: "salvataggio non riuscito",
  errorQuota: "spazio esaurito — impossibile salvare (quota piattaforma)",
  errorGeneric: "operazione non riuscita",
} as const;

export type I18nKey = keyof typeof it;

export function t(key: I18nKey): string {
  return it[key];
}
